export default "__VITE_ASSET__BardZY3D__"